import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type UpdateAccountDemoModeMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateAccountDemoModeInput;
}>;

export type UpdateAccountDemoModeMutationResult = { __typename?: 'Mutation' } & {
  updateAccountDemoMode?: GraphQLTypes.Maybe<
    { __typename?: 'UpdateAccountDemoModePayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UpdateAccountDemoModeDocument = gql`
  mutation updateAccountDemoMode($input: UpdateAccountDemoModeInput!) {
    updateAccountDemoMode(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
